import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Default localStorage for web
import reducer from './reducer';

// Persist configuration
const persistConfig = {
    key: 'root',
    storage, // Use localStorage as default storage
    whitelist: ['yourSliceName'], // Only persist specific slices if needed
};

// Wrap your reducer with `persistReducer`
const persistedReducer = persistReducer(persistConfig, reducer);

// Create store with serializable check disabled for redux-persist actions
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these redux-persist actions
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
            },
        }),
});

// Create the persistor instance
const persister = persistStore(store);

export { store, persister };
